import { Typography } from "antd"

import { HELP_URL } from "../constants/helpUrl"
import { LINKS_STYLE } from "../constants/linkStyle"

const { Link } = Typography

const descriptionRules = [
  {
    when: ({ isUseBinCaidCodes }) => isUseBinCaidCodes,
    value: ({ t }) => (
      <>
        {t(
          "No ARNs? Share your BIN and CAID instead. The Issuer BIN identifies your business Visa payments, and the CAID identifies your merchant account."
        )}{" "}
        <Link style={LINKS_STYLE} href={HELP_URL} target="_blank">
          {t("Learn how to get your BIN and CAID.")}
        </Link>
      </>
    )
  },
  {
    when: ({ isActiveRDR, subStep }) => isActiveRDR && subStep === 2,
    value: ({ t }) => (
      <>
        {t(
          "An Acquirer Reference Number (ARN) is a unique identifier assigned to each card transaction. Please provide ARN codes for transactions no older than 90 days."
        )}{" "}
        <Link style={LINKS_STYLE} href={HELP_URL} target="_blank">
          {t("Learn how to get your ARN’s.")}
        </Link>
      </>
    )
  },
  {
    when: ({ subStep }) => subStep === 1,
    value: ({ t }) => <>{t("To activate alerts, submit all your billing descriptors.")}</>
  }
]

export const getDescription = ({ t, ...flags }) => {
  const rule = descriptionRules.find((r) => r.when(flags))
  if (!rule) return ""
  return rule.value({ t })
}
